import { Link } from "react-router-dom";
import { Icon } from "./Icon";
import "./styles/Form.css";

interface FormSuccessProps {
  title: string;
  message: string;
}

export function FormSuccess({ title, message }: FormSuccessProps) {
  return (
    <div className="form-success" role="status">
      <span className="form-success__icon"><Icon name="check" size={26} /></span>
      <h2>{title}</h2>
      <p>{message}</p>
      <Link to="/" className="btn btn--ghost">Back to the home page</Link>
    </div>
  );
}
